import { type ApolloCache } from '@apollo/client';

import type {
  DeleteCmaReportsComparablesMutation,
  InsertCmaReportsComparablesMutation,
  UpdateCmaReportsComparablesMutation,
} from '@graphql/__generated__/graphql';
import { STEP_LISTINGS_COMPARE_FRAGMENT } from '@modules/reports/cma-reports/cmaReportsQueries';

export const replaceCmaReportComparableListings = (
  cache: ApolloCache,
  cmaReportId: string,
  insertedData: InsertCmaReportsComparablesMutation | null | undefined,
) => {
  const insert_cma_reports_comparables =
    insertedData?.insert_cma_reports_comparables;
  if (!insert_cma_reports_comparables) {
    return;
  }

  cache.modify({
    id: cache.identify({
      __typename: 'cma_reports',
      id: cmaReportId,
    }),
    fields: {
      comparable_listings: () => insert_cma_reports_comparables.returning,
    },
  });
};

export const updateCmaReportCache = (
  cache: ApolloCache,
  cmaReportId: string,
  newData:
    | UpdateCmaReportsComparablesMutation
    | DeleteCmaReportsComparablesMutation
    | null
    | undefined,
) => {
  const cacheId = cache.identify({
    __typename: 'cma_reports',
    id: cmaReportId,
  });

  if (!newData) {
    return;
  }

  const updatedListings =
    'update_cma_reports_comparables' in newData
      ? newData?.update_cma_reports_comparables?.returning[0]?.cma_report
          ?.comparable_listings
      : 'delete_cma_reports_comparables' in newData
      ? newData?.delete_cma_reports_comparables?.returning[0]?.cma_report
          ?.comparable_listings
      : [];

  const existingData = cache.readFragment({
    fragment: STEP_LISTINGS_COMPARE_FRAGMENT,
    fragmentName: 'StepListingsCompare',
    id: cacheId,
  });

  cache.writeFragment({
    fragment: STEP_LISTINGS_COMPARE_FRAGMENT,
    fragmentName: 'StepListingsCompare',
    id: cacheId,
    data: {
      ...existingData,
      updated_at: newData?.update_cma_reports_by_pk?.updated_at,
      comparable_listings: updatedListings,
    },
  });
};
